/**
 * Reports Menu Component
 * Displays a menu of available reports with card-based layout
 */

import React from "react";
import { useNavigate } from "react-router-dom";
import { useResources } from "../../hooks/useResources";
import "./ReportsMenu.scss";

interface ReportCard {
  id: string;
  title: string;
  icon: string;
  path: string;
}

const ReportsMenu: React.FC = () => {
  const navigate = useNavigate();
  const { getResourceValue } = useResources();

  const reports: ReportCard[] = [
    {
      id: "uploaded-questions",
      title: getResourceValue("published_questions_report", "Published Questions Report"),
      icon: "arrow-right-icon",
      path: "/reports/published-questions",
    },
    // Add more reports here as needed
  ];

  const handleReportClick = (path: string) => {
    navigate(path);
  };

  return (
    <div className="reports-menu">
      <div className="reports-menu__container">
        <div className="reports-menu__list">
          {reports.map((report) => (
            <div
              key={report.id}
              className="report-card"
              onClick={() => handleReportClick(report.path)}
              role="button"
              tabIndex={0}
              onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                  e.preventDefault();
                  handleReportClick(report.path);
                }
              }}
            >
              <h3 className="report-card__title">{report.title}</h3>
              <div className="report-card__icon">
                <i className={`f-icon ${report.icon}`}></i>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ReportsMenu;
